import React from 'react';

const PdfIcon = ({ className = '', ariaLabel = 'PDF Icon', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      className={`inline-block align-middle ${className}`}
      fill="currentColor"
      width="1.2em"
      height="1.2em"
      aria-label={ariaLabel}  // Alt text for screen readers
      role="img"              // Specify that this is an image
      {...props}
    >
      <path d="M6.98 32.14V10.53c0-1.82 1.59-3.41 3.41-3.41h28.43c.68 0 1.14 0 1.59.68l15.92 15.92c.45.45.68.91.68 1.59v6.82c0 1.36-4.55 1.36-4.55 0v-4.55H38.81c-1.36 0-2.27-.91-2.27-2.27V11.66H11.53v20.47c0 1.36-4.55 1.36-4.55 0Zm34.12-9.1h8.19l-8.19-8.19v8.19ZM49.63 56.88H45.4c-.66 0-.98-.33-.98-.98V38.21c0-.66.33-.98.98-.98h12.17c.66 0 .98.33.98.98v3.25c0 .66-.33.98-.98.98h-6.96v2.84h4.75c.66 0 .98.33.98.98v3.28c0 .65-.33.98-.98.98h-4.75v5.38c0 .66-.33.98-.98.98ZM34.24 56.88h-9.2c-.65 0-.98-.33-.98-.98V38.21c0-.66.33-.98.98-.98h9.2c2.29 0 3.98.46 5.08 1.36 1.09.91 1.64 2.31 1.64 4.2v8.52c0 1.89-.55 3.29-1.64 4.2-1.09.91-2.78 1.36-5.08 1.36Zm-3.99-14.43v9.28h3.25c.86 0 1.28-.45 1.28-1.34v-6.63c0-.87-.43-1.31-1.28-1.31h-3.25ZM10.66 56.88H6.43c-.65 0-.98-.33-.98-.98V38.21c0-.66.33-.98.98-.98h8.35c1.65 0 2.95.22 3.89.67.94.45 1.6 1.07 1.98 1.87.38.8.57 1.73.57 2.79v3.49c0 1.05-.19 1.98-.57 2.78-.38.8-1.04 1.42-1.98 1.87-.94.45-2.23.67-3.89.67h-3.14v4.53c0 .66-.33.98-.98.98Zm.93-14.55v4.12h2.46c.53 0 .87-.14 1.04-.41.16-.27.25-.58.25-.93v-1.45c0-.36-.08-.68-.25-.94-.16-.26-.51-.4-1.04-.4h-2.46Z"/>
    </svg>
  );
};

export default PdfIcon;